<template lang="pug" functional>
  .list-item-skeleton
    v-card.list-item-skeleton__item(
      v-for="i in props.count"
      :key="i")
      .list-item-skeleton__loader
      .list-item-skeleton__loader
      .list-item-skeleton__loader
      .list-item-skeleton__loader
</template>

<script>
export default {
  name: 'ListItemSkeleton',

  props: {
    count: {
      type: Number,
      default: 7
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';

  .list-item-skeleton {
    margin-top: 4rem;
    
    &__item {
      height: 4.5rem;
      margin-bottom: 1rem;
      padding: 1rem 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__loader {
      height: 2.5rem;
      width: 18rem;
      border-radius: .8rem;

      &:last-child {
        width: 4rem;
        margin-left: 12rem;
      }

      @include skeleton;
    }
  }
</style>
